import { Link as RouterLink, useNavigate } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Card, Link, Container, Typography, CardMedia, Stack } from '@mui/material';
import { useState } from 'react';

// hooks
import useResponsive from '../hooks/useResponsive';
// components
import Page from '../components/Page';
import Logo from '../components/Logo';
import event from '../assets/images/event.png';
// sections
import { LoginForm } from '../sections/auth/login';
import AuthSocial from '../sections/auth/AuthSocial';
import CustomButton from '../components/CustomButton';

// ---------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  zIndex: 9,
  lineHeight: 0,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  padding: theme.spacing(3),
  justifyContent: 'space-between',
  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-start',
    padding: theme.spacing(7, 5, 0, 7),
  },
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  vh: '100%',
  // background: 'radial-gradient(#3E1093 10% , #5516CA 60% );',
  // background: 'linear-gradient(#3E1093 70% , #000 30% );',
  // background: 'linear-gradient(135deg, #5516CA 60%, #2a0273)',
  background: 'linear-gradient(217deg, #5516CA, rgba(255,0,0,0) 100.71%), linear-gradient(127deg, #e66465, rgba(0,255,0,0) 60.71%), linear-gradient(336deg, rgba(0,0,255,.8), rgba(0,0,255,0) 70.71%)',
  maxWidth: '35%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(0, 0, 0, 0),
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(0, 0),
}));

// ----------------------------------------------------------------------

export default function Login() {
  const smUp = useResponsive('up', 'sm');

  const mdUp = useResponsive('up', 'md');

  // ---login
  const navigate = useNavigate();

  return (
    <Page title="Login">
      <RootStyle>
        <Container maxWidth="sm">
          <ContentStyle>
            <Stack pb={3} spacing={3} justifyContent={'start'} alignItems={'start'}>
              <CustomButton type='back' href='/' buttonText={"Retour à l'accueil"} />
              <Logo />
              <Stack justifyContent={'start'} alignItems={'start'} spacing={1}>
                <Typography variant="h5" textAlign='center'>
                  Bon retour !
                </Typography>
                <Typography fontSize={17} textAlign='start' sx={{ color: 'text.secondary' }} >
                  Connectez-vous pour gérer vos évenements
                </Typography>
              </Stack>


            </Stack>

            <LoginForm />


            <Typography fontSize={17} color={'text.secondary'} align="center" sx={{ mt: 3 }}>
              Pas encore de compte ?{' '}
              <Link underline='hover' sx={{ color: '#5E17EB' }} component={RouterLink} to="/register">
                S'inscrire
              </Link>
            </Typography>

          </ContentStyle>
        </Container>
      </RootStyle>
    </Page>
  );
}
